import { createReducer, on } from '@ngrx/store';
import { setConnectionSignStatus } from './connection-sign.actions';

export interface ConnectionState {
  isConnected: boolean;
}

export const initialConnectionState: ConnectionState = {
  isConnected: null
};

export const reducer = createReducer<ConnectionState>(
  initialConnectionState,
  on(setConnectionSignStatus, (state, action) => ({
    ...state,
    isConnected: action.payload.isConnected
  }))
);
